export enum StorageKeysEnum {
  WL_OWNER_VISITING_CUSTOMER = 'wl-owner-visiting-customer',
  SCO_ELAPSED_TIME = 'sco-elapsed-time',
  SCO_UUID = 'sco-uuid',
}
